import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { stat } from 'fs';
// import { Asset } from '@mux/mux-node';
import toast from 'react-hot-toast';

interface state {
  value: Project[];
  current: Project | null;
  newProject: Project | null;
  isLoading: boolean;
  isUploadingPoster: boolean;
  error: string;
}

const initialState: state = {
  value: [],
  current: null,
  isLoading: false,
  newProject: null,
  isUploadingPoster: false,
  error: '',
};

const slice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    resetToInitial(state) {
      state.value = [];
    },
    clearCurrentProject(state) {
      state.current = null;
    },
    resetNewProject(state) {
      state.current = null;
      state.newProject = null;
    },

    //
    getListProjectRequested(state) {
      state.isLoading = true;
    },
    getListProjectSucceeded(state, action: PayloadAction<Project[]>) {
      const projects = action.payload;

      state.value = projects.sort((a, b) => Number(b.id) - Number(a.id));
      state.isLoading = false;
    },
    getListProjectFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;

      state.error = message;
      state.isLoading = false;
    },

    getProjectRequested(state, action: PayloadAction<{ id: number }>) {
      state.isLoading = true;
    },
    getProjectSucceeded(state, action: PayloadAction<Project>) {
      const project = action.payload;

      state.current = project;
      state.isLoading = false;
    },
    getProjectFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;

      state.error = message;
      state.isLoading = false;
    },

    createProjectRequested(state, action: PayloadAction<{ type: string }>) {
      state.isLoading = true;
    },
    createProjectSucceeded(state, action: PayloadAction<Project>) {
      const project = action.payload;

      state.value.push(project);
      state.newProject = project;
      state.isLoading = false;
    },
    createProjectFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;

      state.error = message;
      state.isLoading = false;
    },

    updateProjectRequested(state, action: PayloadAction<{ project: Project }>) {
      state.isLoading = true;
    },
    updateProjectSucceeded(state, action: PayloadAction<{ project: Project }>) {
      const { project } = action.payload;

      state.current = project;
      state.isLoading = false;
      toast.success('Project updated successfully');
    },
    updateProjectFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;

      state.error = message;
      state.isLoading = false;
    },

    uploadPosterRequested(state, action: PayloadAction<{ project: Project; file: File }>) {
      state.isUploadingPoster = true;
      toast('Uploading');
    },
    uploadPosterSucceeded(state, action: PayloadAction<Project>) {
      const project = action.payload;
      const idx = state.value.findIndex((p) => p.id === project.id);

      if (idx !== -1) state.value[idx] = project;
      state.current = project;
      state.isUploadingPoster = false;

      toast.success('Poster uploaded successfully');
    },
    uploadPosterFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;

      state.error = message;
      state.isUploadingPoster = false;
    },
  },
});

export default slice.reducer;
export const {
  // SYNC function
  resetToInitial,
  clearCurrentProject,
  resetNewProject,

  // ASYNC function
  getListProjectRequested,
  getListProjectSucceeded,
  getListProjectFailed,

  getProjectRequested,
  getProjectSucceeded,
  getProjectFailed,

  createProjectRequested,
  createProjectSucceeded,
  createProjectFailed,

  updateProjectRequested,
  updateProjectSucceeded,
  updateProjectFailed,

  uploadPosterRequested,
  uploadPosterSucceeded,
  uploadPosterFailed,
} = slice.actions;
